import publicRuntimeConfig from '../public-runtime-config/publicRuntimeConfig'
import serverRuntimeConfig from '../server-runtime-config/serverRuntimeConfig'

export type Config = {
  API_URL: string,
  MAILSERVICE_URL: string,
  PROFILE_API_URL: string,
  BUILD_NUMBER: string,
  CLIENT_API_ADAPTER_URL: string,
  SERVER_API_ADAPTER_URL: string,
  ASSET_PREFIX: string,
  B2B_WEB_COMPONENTS_BASE_URL: string,
  SALES_FORCE_REGISTER_URL: string,
  SALES_FORCE_LOGIN_URL: string,
  SALES_FORCE_LOGOUT_URL: string,
  DTAP_ENVIRONMENT: string,
  CDN_BASE_URL: string,
  SENTRY_DSN: string,
  REDIRECT_DOMAIN_WHITELIST: string[],
  TOKEN_COOKIE_NAME: string,
  SESSION_COOKIE_NAME: string,
  JOB_PAGE_SIZE: number,
  B2B_TOKEN_PRIVATE_KEY: string,
  TEMPORARY_FILES_SERVICE_API_KEY: string,
  B2B_TOKEN_PUBLIC_KEY: string,
  ID_PROVIDER_CLIENT_ID: string,
  ID_PROVIDER_CLIENT_SECRET: string,
  ID_PROVIDER_REDIRECT_URL: string,
  ID_PROVIDER_METADATA_URL: string,
  TOKEN_ISSUER: string,
  LOG_LEVEL: string,
  JOB_POSTER_API_HOST_URL: string,
  APPLY_SERVICE_HOST_URL: string,
}

const createConfig = (): Config => {
  const config = publicRuntimeConfig()
  const serverRunTimeConfig = serverRuntimeConfig()
  return {
    API_URL: config.apiUrl,
    MAILSERVICE_URL: config.mailServiceUrl,
    PROFILE_API_URL: config.profileApiUrl,
    BUILD_NUMBER: config.buildNumber,
    CLIENT_API_ADAPTER_URL: config.clientApiAdapterUrl,
    SERVER_API_ADAPTER_URL: config.serverApiAdapterUrl,
    ASSET_PREFIX: config.assetPrefix,
    B2B_WEB_COMPONENTS_BASE_URL: config.b2bWebComponentsBaseUrl,
    SALES_FORCE_LOGIN_URL: config.salesForceLoginUrl,
    SALES_FORCE_LOGOUT_URL: config.salesForceLogoutUrl,
    SALES_FORCE_REGISTER_URL: config.salesForceRegisterUrl,
    DTAP_ENVIRONMENT: config.dtapEnvironment,
    CDN_BASE_URL: config.cdnBaseUrl,
    SENTRY_DSN: config.sentryDsn,
    REDIRECT_DOMAIN_WHITELIST: config.redirectDomainWhitelist,
    TOKEN_COOKIE_NAME: config.tokenCookieName,
    SESSION_COOKIE_NAME: config.sessionCookieName,
    JOB_PAGE_SIZE: config.jobPageSize,
    LOG_LEVEL: config.LOG_LEVEL,
    B2B_TOKEN_PUBLIC_KEY: config.b2bTokenPublicKey,
    B2B_TOKEN_PRIVATE_KEY: serverRunTimeConfig.b2bTokenPrivateKey,
    TEMPORARY_FILES_SERVICE_API_KEY: serverRunTimeConfig.temporaryFilesServiceApiKey,
    ID_PROVIDER_CLIENT_ID: serverRunTimeConfig.idProviderClientId,
    ID_PROVIDER_CLIENT_SECRET: serverRunTimeConfig.idProviderClientSecret,
    ID_PROVIDER_REDIRECT_URL: serverRunTimeConfig.idProviderRedirectUrl,
    ID_PROVIDER_METADATA_URL: serverRunTimeConfig.idProviderMetadataUrl,
    TOKEN_ISSUER: serverRunTimeConfig.tokenIssuer,
    JOB_POSTER_API_HOST_URL: config.jobPosterApiHostUrl,
    APPLY_SERVICE_HOST_URL: config.applyServiceHostUrl,
  }
}

export const getConfig = (): Config => createConfig()
